import React, {useState} from "react";
import * as excelJS from "exceljs";
import {saveAs} from "file-saver";
import {RiFileExcel2Fill} from "react-icons/ri";
import Api from "../../../Api/api";
import {toast} from "react-toastify";
import {AES, enc} from "crypto-js";
import {useStateValue} from "../../../states/StateProvider";


const ExcelExportUpselling = ({Gesamt, title, loading, all, len, url, count, rows}) => {
    const workbook = new excelJS.Workbook();
    workbook.creator = "test";
    workbook.lastModifiedBy = "test";
    workbook.created = new Date();
    workbook.modified = new Date();
    const [{
        pageUpselling, sortColumnUpselling, sortMethodUpselling, filterIDUpselling, filterUpselling, secretKey,
    }, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const userID = user.ID
    const [loadingAll, setLoadingAll] = useState(false);
    const fileName = Gesamt ? 'PP-Upselling-Gesamt-' + formatDate(new Date()) + '.xlsx' : 'PP-Upselling-' + formatDate(new Date()) + '.xlsx'

    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
    }

    function formatDate(date) {
        return ([date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate()),].join('-') + '_' + [padTo2Digits(date.getHours()), padTo2Digits(date.getMinutes()),].join('-'));
    }

    async function printXl() {
        let data = new FormData()
        data.append('page', pageUpselling)
        data.append('sort', sortColumnUpselling)
        data.append('sortMethod', sortMethodUpselling)

        if (all) {
            data.append('perPage', rows)
            data.append('filterID', JSON.stringify(filterIDUpselling))
            data.append('filter', JSON.stringify(filterUpselling))
            await prepareData('PP Upselling excel daten', url, data)
        } else {
            data.append('perPage', '10000')
            data.append('filterID', '{"a":null,"b":null,"c":null,"d":null,"e":null,"f":null,"g":null,"h":null,"i":null}')
            data.append('filter', '{"a":null,"b":null,"c":null,"d":null,"e":null,"f":null,"g":null,"h":null,"i":null}')
            await prepareData('PP Upselling Gesamt daten', url, data)
        }
    }

    async function prepareData(Sheet, url, Data) {
        setLoadingAll(true)

        await Api().post(url, Data).then(res => {
            let sheet = workbook.addWorksheet(Sheet);

            let arr = []
            Object.keys(res.data[0]).map(k => {
                const [label, value] = k.split('-')
                if (label !== 'Note' && label !== 'FP_ID' && label !== 'total') {
                    arr.push(label)
                }
            })
            sheet.getRow(1).values = Object.values(arr)

            const row = sheet.getRow(1);
            row.eachCell((cell, rowNumber) => {
                sheet.getColumn(rowNumber).alignment = {
                    vertical: "bottom", horizontal: "left"
                };
                sheet.getColumn(rowNumber).font = {size: 10, family: 2};
                sheet.getRow(1).font = {
                    name: 'Arial Black', color: {argb: '3E4052FF'}, family: 1, size: 10, bold: true
                };
            });

            let keys = []
            Object.entries(res.data[0]).map(v => {
                const [label, value] = v[0].split('-')
                if (v[0] !== 'Note' && v[0] !== 'FP_ID' && v[0] !== 'total') {
                    keys.push({
                        key: v[0], width: all && 25
                    })
                }
            })

            sheet.columns = keys;
            // The key change: Use map to create the new array and assign it!
            const dataToDisplay = res.data.map((item) => {
                const dataTmp = {};
                Object.entries(item).forEach(([key, value]) => {
                    if (key === 'GE_Przt-Durchdringung_GE' || key === 'bAV_Przt-Durchdringung_bAV') {
                        dataTmp[key] = (value*1).toFixed(1) + '%';
                    } else {
                        dataTmp[key] = value;
                    }
                });
                return dataTmp; // Return the modified object
            });

            console.log(dataToDisplay)
            sheet.addRows(dataToDisplay)
            setLoadingAll(false)
        }).catch(e => {
            console.error(e)
            toast.error('Something went wrong!!')
            setLoadingAll(false)
        })
            .finally(e => {
                if (!loadingAll) {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        const blob = new Blob([buffer], {type: "applicationi/xlsx"});
                        saveAs(blob, fileName);
                    });
                }
            })
    }

    return (<div
            className={`${loading || loadingAll ? 'opacity-50' : ''} flex justify-center m-1 cursor-pointer ${(!loading && len === 0 && title !== 'Excel Export Gesamt') && 'hideDiv'} `}
            onClick={printXl}
        >
            <RiFileExcel2Fill className='mr-1' size='25px' color={'#388E3C'}/>
            <span className='mr-1 mb-1 text-grey text-sm'>{!loadingAll ? title : 'wird heruntergeladen...'}</span>
        </div>)
}

export default ExcelExportUpselling
